/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sirius_chain_about = () => `Sirius aims to offer a suite of primary services including blockchain, storage, streaming, and Supercontract. Its architecture allows for the seamless addition of future services without compromising performance. These services are managed and governed by robust consensus protocols, ensuring network integrity while incentivizing decentralized participation. With its parallelized services and protocols organized into distinct layers, Sirius is flexible, easy to adopt, fast, and secure. Packaged within an all-in-one extensible framework, the Sirius ecosystem is well-suited for a range of applications including dApps, DeFi, NFTs, Web3, and beyond.`
